/** Shared transparent artwork, sourced from the repository's /admin-assets library. */
export const ADMIN_ASSETS = {
  bookings: '/admin-assets/shared/empty-states/empty-bookings.png',
  classes: '/admin-assets/shared/empty-states/empty-classes.png',
  events: '/admin-assets/shared/empty-states/empty-events.png',
  payments: '/admin-assets/shared/empty-states/empty-payments.png',
  providers: '/admin-assets/shared/empty-states/empty-providers.png',
  members: '/admin-assets/shared/empty-states/empty-members.png',
  search: '/admin-assets/shared/empty-states/empty-search.png',
  schedules: '/admin-assets/shared/empty-states/empty-schedules.png',
  records: '/admin-assets/shared/empty-states/empty-records.png',
  activity: '/admin-assets/shared/empty-states/empty-activity.png',
  notifications: '/admin-assets/shared/empty-states/empty-notifications.png',
  reports: '/admin-assets/shared/empty-states/empty-reports.png',
  locations: '/admin-assets/shared/empty-states/empty-locations.png',
} as const

export type AdminAsset = keyof typeof ADMIN_ASSETS

export function adminIllustration(illustration: string): string {
  const key = illustration
  if (Object.hasOwn(ADMIN_ASSETS, key)) return ADMIN_ASSETS[key as AdminAsset]
  // Utility flows outside the dashboard retain their existing artwork.
  return `/illustrations/${illustration}.svg`
}
